export default function BtcIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1994_63666)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#F7931A"
        />
        <path
          d="M17.3917 10.515C17.6272 8.943 16.4295 8.09775 14.793 7.53375L15.324 5.40375L14.028 5.08125L13.5105 7.155C13.17 7.0695 12.8205 6.99 12.4717 6.9105L12.993 4.82325L11.697 4.5L11.166 6.62925C10.8835 6.56575 10.6075 6.50075 10.338 6.43425L10.3395 6.4275L8.55149 5.98125L8.20649 7.36575C8.20649 7.36575 9.16874 7.58625 9.14849 7.59975C9.67349 7.731 9.76799 8.07825 9.75224 8.35425L9.14774 10.7805C9.18424 10.789 9.22924 10.8032 9.28274 10.8232L9.14549 10.7895L8.29799 14.1885C8.23349 14.3475 8.07074 14.5867 7.70324 14.496C7.71674 14.5147 6.76124 14.2612 6.76124 14.2612L6.11774 15.7448L7.80524 16.1655C8.11874 16.2443 8.42624 16.3267 8.72849 16.404L8.19224 18.558L9.48749 18.8805L10.0185 16.7505C10.372 16.8455 10.7165 16.9347 11.052 17.0182L10.5225 19.1392L11.8185 19.4618L12.3547 17.3123C14.5657 17.7308 16.2277 17.562 16.9275 15.5625C17.4915 13.953 16.8997 13.0238 15.7365 12.4185C16.584 12.2235 17.2215 11.6663 17.3917 10.515ZM14.4292 14.6685C14.0295 16.2788 11.3182 15.408 10.4392 15.1898L11.1517 12.336C12.0307 12.5557 14.8485 12.99 14.4292 14.6685ZM14.8305 10.4918C14.4652 11.9565 12.2092 11.2118 11.478 11.0295L12.123 8.442C12.8542 8.62425 15.2115 8.964 14.8305 10.4918Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1994_63666">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
